import React from "react";
import { Phone } from "lucide-react";
import { SITE } from "@/mock";

/**
 * MobileCallBar - sticky bottom "Call Now" bar shown only on mobile.
 * Sits below the floating accessibility button (which is raised on mobile).
 */
export default function MobileCallBar() {
  return (
    <div className="fixed bottom-0 left-0 right-0 z-[55] border-t border-neutral-800 bg-neutral-900 px-3 py-2 lg:hidden">
      <a
        href={SITE.phoneHref}
        className="flex w-full items-center justify-center gap-2 rounded-full bg-[#D0021B] py-3.5 text-sm font-bold uppercase tracking-wide text-white transition-colors hover:bg-[#a80016] active:bg-[#a80016]"
        aria-label={`Call MattressTown at ${SITE.phone}`}
      >
        <Phone className="h-5 w-5" aria-hidden="true" />
        Call Now · {SITE.phone}
      </a>
    </div>
  );
}
